import './page.css';

export class Page {
	
}